import callApi, { BaseResponseDto, BaseResponsePagedDto } from "./baseRequest";
import { UsersResponse } from "./userService";

const route = 'customer';

export interface CustomerData {
    partnerResponseDtos: PartnerResponse[],
    salesDataResponseDto: SalesResponse[],
    paymentTermResponseDto: PaymentTermResponse[],
    defaultDataResponseDto: DefaultDataResponse[],
    veichleTypeResponseDto: VeichleTypesResponse[],
}

interface VeichleTypesResponse {
    id: string,
    maxValue: number,
    minValue: number,
    tm: string,
    incoterm: string,
    veichleDescriptions: VeichleDescResponse[],
    tms: VeichleTMSResponse[],
}

export interface VeichleDescResponse {
    id: string,
    description: string,
    lang: string,
}

export interface VeichleTMSResponse {
    id: string,
    tm: string,
    veichleId: string,
}

interface PartnerResponse {
    SalesOrganization: string,
    DistributionChannel: string,
    ActivitySector: string,
    PartnerRole: string,
    Partner: string,
    Name: string,
    Telephone: string,
    Email: string,
}

interface SalesResponse {
    SalesOrganization: string,
    DistributionChannel: string,
    ActivitySector: string,
    CustomersGroup: string,
    CustomersGroup3: string,
    PriceGroup: string,
    Incoterms1: string,
    Incoterms2: string,
    PaymentCondition: string,
    ToBeDeleted: string,
}

interface PaymentTermResponse {
    Language: string,
    PaymentCondition: string,
    Description: string,
}

interface DefaultDataResponse {
    SalesOrganization: string,
    DistributionChannel: string,
    Material: string,
    ItemCategory: string,
    Incoterm: string,
    PaymentCondition: string,
    FreightMaterialAgent: string,
    FreightAgent: string,
    FreightAgentName: string,
}

export interface CustomerResponseDto {
    id: string,
    issuer: string,
    issuerName: string,
    country: string,
    city: string,
    postalCode: string,
    region: string,
    address: string,
    neighborhood: string,
    cnpjCpf: string,
    email: string,
    taxDomicile: string,
    accountsGroup: string,
    toBeDeleted: string,
    searchTerm1: string,
    searchTerm2: string,
    enabledOrderAfterHour: boolean
}

export function getCustomerDataByIssuer(issuerCode: string, materialCode: string): Promise<BaseResponseDto<CustomerData>> {
    const result: BaseResponseDto<CustomerData> = {
        data: {
            defaultDataResponseDto: [],
            partnerResponseDtos: [],
            paymentTermResponseDto: [],
            salesDataResponseDto: [],
            veichleTypeResponseDto: [],
        },
        error: '',
        success: false
    };

    const response = callApi('GET', `${route}/customer-details/${issuerCode}?materialCodes=${materialCode}`)
    .then(resp => {
        if (resp.data) {
            result.data = {
                partnerResponseDtos: resp?.data?.Partners,
                defaultDataResponseDto: resp?.data?.DefaultData,
                paymentTermResponseDto: resp?.data?.PaymentTerm,
                salesDataResponseDto: resp?.data?.SalesData,
                veichleTypeResponseDto: resp?.data.VeichleTypes,
            };
            result.success = true;
        }

        return result;
    })
    .catch(err => {
        result.error = err;

        return result;
    })

    return response;
};

export function getCustomerPaged(
    take: number,
    skip: number,
    search: string): Promise<BaseResponsePagedDto<CustomerResponseDto[]>> {
    const result: BaseResponsePagedDto<CustomerResponseDto[]> = {
        error: '',
        data: [],
        success: false,
        currentTake: take,
        totalItems: 0,
        totalPages: 0
    };

    const response = callApi('GET', `${route}/get-all-paged?take=${take}&skip=${skip}&search=${search}`)
        .then(response => {
            result.success = true;

            if (response.data) {
                result.data = response.data
                result.totalItems = response.totalItems
                result.totalPages = response.totalPages
            }
            return result;
        }).catch(err => {
            result.error = err.error;

            return result;
        });

    return response;
}

export function getUserByCustomerPaged(issuer: string): Promise<BaseResponseDto<UsersResponse[]>> {
    const result: BaseResponseDto<UsersResponse[]> = {
        error: '',
        data: [],
        success: false
    };

    const response = callApi('GET', `${route}/get-users-customer/${issuer}`)
        .then(response => {
            result.success = true;

            if (response.data) {
                result.data = response.data
            }
            return result;
        }).catch(err => {
            result.error = err.error;

            return result;
        });

    return response;
}

export function putEnabledAfterHour(issuer: string, enabled: boolean): Promise<BaseResponseDto<boolean>> {
    const result: BaseResponseDto<any> = {
        data: {},
        error: '',
        success: false
    };

    const response = callApi('PUT', `${route}/enable-after-hour/${issuer}/${enabled}`)
    .then(resp => {
        result.success = true;
        return result;
    })
    .catch(err => {
        result.error = err;

        return result;
    })

    return response;
};

export function getAllCustomer(): Promise<BaseResponsePagedDto<CustomerResponseDto[]>> {
    const result: BaseResponsePagedDto<CustomerResponseDto[]> = {
        error: '',
        data: [],
        success: false,
        currentTake: 0,
        totalItems: 0,
        totalPages: 0
    };

    const response = callApi('GET', `${route}/get-all-customer`)
        .then(response => {
            result.success = true;

            if (response.data) {
                result.data = response.data.customers
            }
            return result;
        }).catch(err => {
            result.error = err.error;

            return result;
        });

    return response;
}